import style from './style.module.css'

/**
 * company.stats arrives pre-formatted as { value, label } and is 1–4 entries
 * long, so the tiles are laid out with an auto-column grid that splits the row
 * evenly whatever the count.
 */
const StatsBlock = ({ stats = [] }) => {
  const items = (Array.isArray(stats) ? stats : []).slice(0, 4)

  if (!items.length) {
    return (
      <div className={style.companyModal_stats}>
        <div className={style.companyModal_stats_empty}>
          <span>No figures yet</span>
        </div>
      </div>
    )
  }

  return (
    <div className={style.companyModal_stats}>
      {items.map((stat) => (
        <div className={style.companyModal_stats_item} key={`${stat.label}-${stat.value}`}>
          <span className={style.companyModal_stats_item_number}>{stat.value}</span>
          <span className={style.companyModal_stats_item_currency}>{stat.label}</span>
        </div>
      ))}
    </div>
  )
}

export default StatsBlock
